import { render, staticRenderFns } from "./AdminDataPrivacy.vue?vue&type=template&id=4bbc8260&"
import script from "./AdminDataPrivacy.vue?vue&type=script&lang=js&"
export * from "./AdminDataPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports